import BasicButton from 'components/BasicButton';
import BasicButtonGroup from 'components/BasicButtonGroup';
import BasicSubmitButton from 'components/BasicSubmitButton';

import LoadMask from 'components/LoadMask';
import {ANIMATION_TIMEOUT_APPEAR} from 'constants/animation.js';
import {ErrorMessage, Formik} from 'formik';
import isArray from 'lodash/isArray'
import React from 'react';

import {CSSTransition} from 'react-transition-group';
import BasicLabel from '../../../../components/BasicLabel'
import BasicTextArea from '../../../../components/BasicTextArea'
import CheckboxOrRadioGroup from '../../../../components/CheckboxOrRadioGroup'
import ERROR_FIELD from '../../../../constants/error-fields'
import ResponseErrorDialog from '../../../Dialog/components/ResponseErrorDialog'

import './styles.css';
import {ValidationSchema} from './validate';

const AccountDeleteReasonForm = props => {
  const { proceed, dismiss } = props.actions;
  const { value } = props.params;

  const onSubmitError = (response, setErrors) => {
    const {
      data: { errors: fields },
    } = response;
    if (fields && typeof setErrors === 'function') {
      const obj = {};
      for (let [key, value] of Object.entries(fields)) {
        const error = isArray(value) ? value[0] : value;
        obj[key] = ERROR_FIELD[error] || `${error}`;
      }
      setErrors(obj);
    } else {
      ResponseErrorDialog({ response });
    }
  };
  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false)
    if (values.Reason.includes('Other') && values.Message && values.Message.trim() === '') {
      onSubmitError({data: {
        errors: {
          Message: 'Please briefly state the reason'
        }
        }}, setErrors)
    } else {
      proceed(values);
    }
  };

  return (
    <CSSTransition
      in={true}
      appear={true}
      timeout={ANIMATION_TIMEOUT_APPEAR}
      classNames="fade"
    >
      <div className="form__inner">
        <p>To help us improve, please tell us why you’re leaving (check all that apply):</p>
        <Formik
          initialValues={{
            Reason: value,
            Message: '',
          }}
          validationSchema={ValidationSchema}
          onSubmit={onSubmit}
        >
          {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue
            }) => (
            <form onSubmit={handleSubmit} className="form__content">
              {isSubmitting && <LoadMask/>}
              <div className="form__group form__group--compact" style={{marginBottom: 0}}>
                <CheckboxOrRadioGroup
                  name={'Reason'}
                  type={'checkbox'}
                  multiSelect={true}
                  selectedOptions={values.Reason}
                  options={[
                    'Am no longer recruiting for the buy-side (found a buy-side role)',
                    'Am no longer recruiting for the buy-side (didn\'t find a role)',
                    'Am still recruiting for the buy-side but working with other recruiters',
                    'Didn\'t like the website or found it difficult to navigate',
                    'Did not see opportunities that were of interest',
                    'Have concerns regarding privacy or visibility',
                    'Received too many emails',
                    'Other',
                  ]}
                  controlFunc={(val) => {
                    setFieldValue('Reason', val);
                  }}
                />
              </div>
              <div className="form__group form__group--compact">
                <BasicLabel
                  name="Message"
                  required={false}
                  text="Additional comments"
                />
                <BasicTextArea
                  rows={10}
                  maxlength={15001}
                  name="Message"
                  content={values.Message}
                  resize={false}
                  placeholder="0 characters of the 15000 character limit"
                  controlFunc={handleChange}
                  touchFunc={handleBlur}
                  isValid={(!errors.Message && touched.Message) || !touched.Message}
                />

                <ErrorMessage
                  name="Message"
                  render={message => (
                    <div className="form__error" dangerouslySetInnerHTML={{__html: message || errors.Message}}></div>
                  )}
                />
              </div>
              <div className="form__controls form__controls--compact">
                <BasicButtonGroup
                  groupStyles={{width: '100%', justifyContent: 'center'}}
                >
                  <BasicButton
                    controlFunc={dismiss}
                    btnWidth={200}
                    btnHeight={40}
                    btnFontWeight={500}
                    btnArrow={false}
                    btnTextColor="#27282d"
                    btnText="Cancel"
                  />
                  <BasicSubmitButton
                    controlFunc={handleSubmit}
                    btnWidth={200}
                    btnHeight={40}
                    btnFontWeight={500}
                    btnArrow={false}
                    btnTextColor="#27282d"
                    btnText="Confirm"
                  />
                </BasicButtonGroup>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </CSSTransition>
  );
};

export default AccountDeleteReasonForm;
